import env from '../config/env';
import { getService, postBodyService } from "./base.service";
import config from "../config/application";
import permission from '../api/permissions.service';
import dictionary from '../config/dictionary';
//url
const createType = 'add';
const deleteType = 'delete';
const updateType = 'update';
const listConcept = 'find_all_concept';
const findByIdConcept = 'find_by_concept';
const findByConceptName = 'find_by_concept_name';
const saveConceptUrl = 'add_concept';

class TypeService {
    getConcepts() {
        const url = `${config.data.configuration.type.url}${listConcept}`;
        return getService(url);
    }
    findByConcept(conceptName) {
        const url = `${config.data.configuration.type.url}${findByConceptName}/${conceptName}`;
        return getService(url);
    }
    async getTypeByConcept(username, concept) {
        let valid = await permission.validPermission(
            env.transaction.type,
            username,
            env.app.systemCode, dictionary.configApp.action.list);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.type.url}${findByIdConcept}/${concept}`;
            return getService(url);
        } else {
            return valid;
        }
    }
    async getCreateType(type, username) {
        let valid = await permission.validPermission(
            env.transaction.type,
            username,
            env.app.systemCode, dictionary.configApp.action.add);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.type.url}${createType}`;
            return postBodyService(url, type);
        } else {
            return valid;
        }
    }

    async getUpdateType(type, username) {
        let valid = await permission.validPermission(
            env.transaction.type,
            username,
            env.app.systemCode, dictionary.configApp.action.edit);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.type.url}${updateType}`;
            return postBodyService(url, type);
        } else {
            return valid;
        }
    }
    async getDeleteType(lsData, username) {
        let valid = await permission.validPermission(
            env.transaction.type,
            username,
            env.app.systemCode, dictionary.configApp.action.delete);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.type.url}${deleteType}`;
            return postBodyService(url, lsData);
        } else {
            return valid;
        }
    }
    async saveConcept(concept, username) {
        let valid = await permission.validPermission(
            env.transaction.type,
            username,
            env.app.systemCode, dictionary.configApp.action.add);

        if (valid.response === undefined && valid.data.allow === true) {
            const url = `${config.data.configuration.type.url}${saveConceptUrl}`;
            return postBodyService(url, concept);
        } else {
            return valid;
        }
    }
}

export default new TypeService();